import React from 'react';
import SkeletonElement from '../../SkeletonElement';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SkeletonDeal = function SkeletonDeal(_ref) {
  var shape = _ref.shape;
  var addCssByShape = function addCssByShape() {
    switch (shape) {
      case 'square':
        return 'w-[350px] h-[350px] ';
      case 'rectangle':
        return 'w-[500px] ';
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex  flex-col lg:items-center mx-auto p-2  w-full lg:w-full 3xl:w-[365px] lg:flex-row lg:gap-8",
    children: [/*#__PURE__*/_jsx("div", {
      className: "lg:w-[50%]  sm:w-full  ",
      children: /*#__PURE__*/_jsx(SkeletonElement, {
        type: "thumbnail",
        size: "h-36  w-full   lg:h-[400px]"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "lg:w-[50%]",
      children: [/*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: "w-[65%] h-5",
        style: "rounded-none mt-3"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "title",
        size: "w-[35%] h-5",
        style: "rounded-none mt-2"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: "w-[55%] h-5",
        style: "rounded-none mt-4"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "title",
        size: "w-[25%] h-5",
        style: "rounded-none mt-3"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-4"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-1"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: "w-[65%] h-5",
        style: "rounded-none mt-7 "
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-4"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-1"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-4"
      }), /*#__PURE__*/_jsx(SkeletonElement, {
        type: "text",
        size: " w-[95%] h-5",
        style: "rounded-none mt-1"
      })]
    })]
  });
};
export default SkeletonDeal;